import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

export const ScreeningQuestionStatus = ({ screening, busy, error, onRefresh }) => {
  const hasAnswers = (screening?.responses || []).length > 0;
  const canRefresh = screening?.status === 'In Progress' && !hasAnswers;
  let message = screening?.question_bank_id ? 'The matched question bank has no questions yet.' : 'No matching questions are available yet.';
  if (hasAnswers) message = 'This screening has saved responses but no question snapshot. Your responses have been preserved.';
  else if (screening?.status !== 'In Progress') message = 'This closed screening has no saved questions.';
  return <section className="text-center py-8 space-y-4" data-testid="screening-empty-questions">
    <AlertCircle className="h-12 w-12 text-amber-500 mx-auto" />
    <p data-testid="screening-no-bank" className="text-slate-600 [overflow-wrap:anywhere]">{message}</p>
    {screening?.question_bank_name && <p data-testid="screening-empty-bank-name" className="text-sm text-slate-500 [overflow-wrap:anywhere]">{screening.question_bank_name}</p>}
    {error && <p role="alert" data-testid="screening-questions-error" className="text-sm text-red-700 [overflow-wrap:anywhere]">{error}</p>}
    {canRefresh && <Button data-testid="screening-refresh-questions" variant="outline" disabled={busy} onClick={onRefresh}>
      <RefreshCw className={`h-4 w-4 mr-2 ${busy ? 'animate-spin' : ''}`} />{busy ? 'Checking questions…' : 'Refresh questions'}
    </Button>}
  </section>;
};